export default __webpack_public_path__ + "static/media/list-22220a.41a20dd7.svg";